import { ProductPack, Product } from "@r6digital/rapidstor-types/types/Merchandise";
import { LineItem } from "./LineItem";
import * as Constants from "../../generalConstants";

export const productPackTransformer = (productPack: ProductPack): LineItem => {
  return {
    name: productPack.name,
    _id: productPack._id,
    key: productPack.name,
    total: productPack.value.displayPrice,
    active: false,
    discounted: !(productPack.value.displayPrice === productPack.price.displayPrice),
    discountedRate: productPack.price.displayPrice,
    type: productPack.category?.title,
    contents: productPack.inventories,
    category: "packaging-+-extras",
  };
};

export const productTransformer = (product: Product): LineItem => {
  const matchedBundleIndex = Constants.BUNDLE_PRODUCTS.findIndex(
    (bname) => bname === product.name
  );
  const matchedBundle = Constants.BUNDLES[matchedBundleIndex];
  return {
    name: matchedBundle.name,
    line_item_name: matchedBundle.line_item_name,
    _id: product._id,
    key: matchedBundle.key,
    total: matchedBundle.total,
    active: false,
    discounted: matchedBundle.discounted,
    discountedRate: matchedBundle.discountedRate,
    type: matchedBundle.type,
    contents: matchedBundle.contents,
    category: "packaging-+-extras",
  };
};
